export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14589.e88cc72c.jpg";